import { Download } from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import {
  Box,
  CircularProgress,
  Grid2,
  IconButton,
  MenuItem,
  TableCell,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useMeasure from "react-use-measure";
import {
  addDameNotes,
  deleteDameNote,
  DownloadResume,
  getDameNotes,
  shareCoverSheet,
  updateDameNote,
} from "../../../api/Api";
import AccordingAttachmentIco from "../../../assets/icons/AccordingAttachementIco";
import AccordingNoteIco from "../../../assets/icons/AccordingNoteIco";
import AnomalyStarIco from "../../../assets/icons/AnomalyStarIco";
import AnomalyTickIco from "../../../assets/icons/AnomalyTickIco";
import BasicInfoIco from "../../../assets/icons/BasicInfoIco";
import CalenderIco from "../../../assets/icons/CalenderIco";
import CandidateHub from "../../../assets/icons/CandidateHub";
import ClipBoardCheck from "../../../assets/icons/ClipBoardCheckIco";
import DeleteIco from "../../../assets/icons/DeleteIco";
import EditInfoIco from "../../../assets/icons/EditInfoIco";
import ExperienceIco from "../../../assets/icons/ExperienceIco";
import EyeIco from "../../../assets/icons/EyeIco";
import Prediction from "../../../assets/icons/PredictionIco";
import ProbabilityHire from "../../../assets/icons/ProbabilityHireIco";
import ProbabilityInterviewIco from "../../../assets/icons/ProbabilityInterviewIco";
import RescoreIco from "../../../assets/icons/RescoreIco";
import RescoreMenuItemIco from "../../../assets/icons/RescoreMenuItemIco";
import ShareIco from "../../../assets/icons/ShareIco";
import StarFlightico from "../../../assets/icons/StarFlightIco";
import CommonButton from "../../../component/Button";
import CommonLinearProgress from "../../../component/Linearprogress";
import SnackBar from "../../../component/SnackBar";
import {
  GetCalendlyEventTypes,
  ReferenceShareClick,
  SendCalendlyInvite,
} from "../../../redux/action/Candidate";
import {
  AttachementCreateCall,
  AttachementDelete,
  AttachementDownload,
  AttachementTableGetCall,
  JobCandidateQueationEnable,
  JobEditCandidate,
  JobJobReScore,
  JobJobRescore,
  JobJobShare,
  JobResumeDuplicate,
  StatusChange,
} from "../../../redux/action/Job";
import { CreateSubmissionDocument } from "../../../redux/action/Submission";
import {
  DELETE,
  GET,
  GETDOWNLOAD,
  POST,
  PUT,
} from "../../../redux/axios/Axios";
import { buildUrl, GetFileIcon } from "../../../utils/constants";
import CommonTable from "../../candidates/Table";
import { CustomDiv } from "../../chat-bot/style";
import AddUpdateNote from "../../common-components/AddUpdateNote";
import CommonAccordion from "../../common-components/CommonAccordion";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import DeleteNote from "../../common-components/DeleteNote";
import {
  CommonGrid2,
  DotColor,
  StyledFlexRowView,
  StyledTableBodyTableCell,
} from "../../common-components/StyledComponents";
import ShareQuickMatch from "../../matches/quick-match/components/ShareQuickMatch";
import {
  FileContainer,
  StyledLinearContainer,
} from "../../matches/quick-match/components/StyledComponent";
import Notes from "../job-information/notes";
import {
  CommonTippy,
  CustomizeMenu,
  CustomizeSpan,
  TooltipParagraph,
} from "../style";
import AddPreScreenQuestions from "./components/AddPreScreenQuestions";
import AttachmentDialog from "./components/AttachementDialog";
import Attachment from "./components/Attachment";
import BasicInfo from "./components/BasicInfo";
import InteractionDialog from "./components/Dialogbox";
import DialogCandidateHub from "./components/DialogCandidateHub";
import EditCandidateProfile from "./components/EditCandidateDialog";
import Experience from "./components/Experience";
import Predictions from "./components/Predictions";
import PreScreenQuestions from "./components/PreScreenQuestions";
import ProfileInformation from "./components/ProfileInformation";
import Result from "./components/Result";
import ScheduleInterview from "./components/ScheduleInterview";
import SpiderGraph from "./components/SpiderGraph";
import Summary from "./components/Summary";
import Review from "./components/Review";

function JobsCandidate({
  matchedData,
  resumeId,
  resumeLoader,
  filteredResumeTab,
  fetchResumeData,
  fetchData,
  handleQuestionMarkClick,
  iconVisible,
  chatBotData,
  condition_based = false,
  open,
  jobData,
  dummy_value = 0,
}) {
  const [ref, bounds] = useMeasure();
  const [noteList, setNoteList] = useState([
    { note: "", interaction: "Email", added_by: "username" },
  ]);
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const query = new URLSearchParams(useLocation().search);
  const queryValue = query?.get("value") - dummy_value;
  const jobStatus = query.get("status");
  const jobId = query.get("id");
  const title = query.get("title");
  const matchId = query.get("match-id");
  const candidateName = matchedData?.resume_info?.candidate_name || "";
  const getBreadcrumb = query.get("breadcrumbs");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [noteId, setNoteId] = useState("");
  const [notesTableList, setNotesTableList] = useState([]);
  const [attachementRowData, setAttachementRowData] = useState({});
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [viewResume, setViewResume] = useState({
    open: false,
    disabled: false,
    duplicateLoading: false,
    replacedLoading: false,
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [menuViewLoader, setMenuViewLoader] = useState(false);
  const [menuLoading, setMenuLoading] = useState({
    downloadMenuLoader: false,
    disabled: false,
    referenceLoading: false,
    submissionLoading: false,
  });
  const [shareDialogOpen, setShareDialogOpen] = useState({
    open: false,
    loading: false,
  });
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [candidateProfileValue, setCandidateProfileValue] =
    useState("In Progress");
  const [copied, setCopied] = useState(false);
  const JobRescore = useSelector((state) => state.jobs.jobJobRescore);
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
    value: "",
    hiredOpen: false,
    hiredLoading: false,
  });
  const [review, setReview] = useState({
    open: false,
    markLoading: false,
    disabled: false,
  });
  const statusOptions = [
    { name: "Selected", color: "#17B26A", id: "Selected" },
    { name: "In Progress", color: "#9E77ED", id: "In Progress" },
    { name: "Rejected", color: "#F04438", id: "Rejected" },
  ];
  const noteHeaderData = [
    { name: "Title", direction: "asc", sort: false, width: "50%" },
    { name: "Created By", direction: "asc", sort: false, width: "20%" },
    { name: "Date", direction: "asc", sort: false, width: "15%" },
    { width: "15%" },
  ];
  const interactionHeaderdata = [
    { name: "ID", direction: "asc", sort: false },
    { name: "Made By", direction: "asc", sort: false },
    { name: "Type", direction: "asc", sort: false },
    { name: "Action", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Created At", direction: "asc", sort: false },
    { width: "5%" },
  ];
  const [interAction, setInterAction] = useState({
    data: {},
    open: false,
  });
  const [attachmentList, setAttachmentList] = useState({
    data: [],
    loading: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [attachementOpen, setAttachmentOpen] = useState(null);
  const [attachmentDialog, setAttachmentDialog] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const [attachementMenuLoader, setAttachementMenuLoader] = useState({
    download: false,
    view: false,
    delete: false,
  });
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [enableQuestion, setEnableQuestion] = useState({
    open: false,
    status:
      matchedData?.insights?.feedback?.enable_pre_screen_questions || false,
    disabled: false,
    confirmLoading: false,
    leaveLoading: false,
    content: "",
  });
  const [editDialog, setEditDialog] = useState({
    open: false,
    disabled: false,
    cancelLoading: false,
    saveLoading: false,
  });
  const [reScore, setReScore] = useState({
    noLoading: false,
    disabled: false,
    yesLoading: false,
    open: false,
  });
  const [matchSelected, setMatchSelected] = useState({
    name: "Overall",
    loading: false,
    disabled: false,
  });
  const [expandedPanel, setExpandedPanel] = useState([""]);
  const [calendlyEvent, setCalendlyEvent] = useState({
    data: [],
    loading: false,
    open: false,
  });
  const [preScreen, setPreScreen] = useState({
    open: false,
    disabled: false,
    saveLoading: false,
  });

  const fetchCalendlyEventTypes = async () => {
    try {
      const res = await GetCalendlyEventTypes();
      setCalendlyEvent((prev) => ({
        ...prev,
        data: res.data,
      }));
    } catch (error) {
      // setSnackbarState({
      //   open: true,
      //   message: error.message,
      //   severity: "error",
      // });
    }
  };

  const handleScheduleInterview = () => {
    setCalendlyEvent((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleScheduleSubmit = async (values) => {
    try {
      setCalendlyEvent((prev) => ({
        ...prev,
        loading: true,
      }));
      const payload = {
        event_name: values.event.name,
        event_url: values.event.scheduling_url,
        subject: "Interview Invitation – Screening Round",
        message: "Hi, please pick a slot at your convenience.",
        candidate_name: matchedData?.candidate_name,
        candidate_email: matchedData?.email,
      };
      const response = await SendCalendlyInvite(matchedData.id, payload);
      setSnackbarState({
        open: true,
        severity: "success",
        message: response.message || "Calendly invite sent successfully.",
      });
      handleCalendlyClose();
    } catch (error) {
      setCalendlyEvent((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message || "An error occurred.",
      });
    }
  };

  const handleCalendlyClose = () => {
    setCalendlyEvent((prev) => ({
      ...prev,
      open: false,
      loading: false,
    }));
  };

  //SpiderGraph
  const [getJustification, setGetJustification] = useState({
    title: "",
    name: "",
    payload: "",
  });
  console.log(matchedData?.resume_info?.willing_to_relocate, "willing_to_relocate");
  const relocate =matchedData?.resume_info?.willing_to_relocate?.toLowerCase?.();
  //profile Information
  const section_1_data = [
    { title: "Inferred Title", content: matchedData?.inferred_title || "-" },
    {
      title: matchedData?.pay_rate?.label,
      content: matchedData?.pay_rate?.value || "-",
    },
    {
      title: matchedData?.location?.label,
      content: matchedData?.location?.value || "-",
      icon: matchedData?.location?.flag,
    },
    {
      title: "Highest Degree",
      content: matchedData?.resume_info?.highest_degree || "-",
      isLink: true,
    },
    // Section-2
    {
      title: "Industries",
      contentKey: matchedData?.resume_info?.industry_info || [],
    },
    {
      title: "Occupational Classification",
      contentKey:
        matchedData?.resume_info?.occupational_classification_info || [],
    },
    {
      title: "Countries",
      contentKey: matchedData?.resume_info?.country_info || [],
    },
    { title: "Website", isLink: "-" },

    // Section-3
    {
      title: "Email Address",
      copyContent: matchedData?.resume_info?.email || "-",
    },
    {
      title: "Mobile Number",
      content: matchedData?.resume_info?.phone_number || "-",
    },
    // {
    //   title: "Willing to Relocate",
    //   content:
    //     matchedData?.resume_info?.willing_to_relocate.toLowerCase() === "yes" ||
    //     matchedData?.resume_info?.willing_to_relocate.toLowerCase() === "no"
    //       ? matchedData?.resume_info?.willing_to_relocate
    //       : "-",
    // },
    {
  title: "Willing to Relocate",
  content:
    relocate === "yes" || relocate === "no"
      ? matchedData?.resume_info?.willing_to_relocate
      : "-",
},
    {
      title: "Notice Period",
      content: matchedData?.resume_info?.notice_period || "-",
    },
    {
      title: "Citizenship/Visa Status",
      content: matchedData?.resume_info?.visa_status?.visa_type || "-",
      tooltipData: {
        validFrom: matchedData?.resume_info?.visa_status?.visa_valid_from,
        validTo: matchedData?.resume_info?.visa_status?.visa_valid_to,
        holderCompanyName:
          matchedData?.resume_info?.visa_status?.H1B_holder_company_name,
        visaStampedInPassport:
          matchedData?.resume_info?.visa_status?.visa_stamped,
      },
    },
  ];

  const [dotAnchorEl, setDotAnchorEl] = React.useState(null);
  const [anchorElCompare, setAnchorElCompare] = React.useState(null);
  const openDot = Boolean(dotAnchorEl);
  const openCompare = Boolean(anchorElCompare);

  const handleClickDot = (event) => {
    setDotAnchorEl(event.currentTarget);
  };
  const handleCloseDot = () => {
    setDotAnchorEl(null);
  };

  const handleCloseCompare = () => {
    setAnchorElCompare(null);
  };
  const handleClickCompare = (event) => {
    setAnchorElCompare(event.currentTarget);
  };

  const handleDownloadAttachment = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: true,
      }));

      const response = await AttachementDownload(attachementRowData.id);
      let filename = attachementRowData.file_name || "download";
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);

      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setAnchorEl(null);
      setAttachmentOpen(null);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachmentClick = () => {
    setAnchorEl(null);
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      id: attachementRowData.id,
      content: attachementRowData.name,
    }));
  };

  const handleDeleteAttachment = async () => {
    try {
      setDeleteButton((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await AttachementDelete(deleteButton?.id);
      await fetchAttachmentTableList(resumeId);
      handelAttachmentDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleFileView = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: true,
      }));

      // const fileExtension = attachementRowData.type.toLowerCase();

      const response = await AttachementDownload(attachementRowData.id);

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        attachementRowData.file_path
      )}`;

      const isDocValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["doc", "docx"].includes(ext);
      };

      const isPdfValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["pdf"].includes(ext);
      };

      if (isDocValidFile(attachementRowData.file_name)) {
        window.open(officeViewerUrl, "_blank");
      } else if (isPdfValidFile(attachementRowData.file_name)) {
        window.open(blobUrl, "_blank");
      }
      setAnchorEl(null);
      setAttachmentOpen(null);
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const attachmentMenuData = [
    {
      title: "View",
      disabled: attachementMenuLoader.view || attachementMenuLoader.download,
      image: attachementMenuLoader.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleFileView();
      },
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      disabled:
        attachementMenuLoader.delete ||
        attachementMenuLoader.download ||
        attachementMenuLoader.view,
      onClick: handleDeleteAttachmentClick,
    },
    {
      title: "Download",
      disabled: attachementMenuLoader.download || attachementMenuLoader.view,
      image: attachementMenuLoader.download ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "20px" }} />
      ),
      onClick: handleDownloadAttachment,
    },
  ];

  const attachementHeaderData = [
    { name: "Name", width: "23%" },
    { name: "Type", width: "20%" },
    { name: "Status" },
    { name: "Created by" },
    { name: "Created Date" },
    {},
  ];

  const handleClickAddNote = () => {
    setOpenNoteDialog(true);
  };

  const handleCloseNoteDialog = () => {
    setNoteId("");
    setOpenNoteDialog(false);
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleDeleteNote = (row) => {
    setDeleteNoteDialogOpen(true);
    setNoteId(row?.id);
    setNoteList([
      {
        note: row?.note,
        interaction: row?.interaction,
        added_by: row?.added_by,
        created_at: row?.created_at,
      },
    ]);
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    setNoteId("");
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleUpdateNote = (row) => {
    if (row?.id) {
      setNoteId(row?.id);
      setOpenNoteDialog(true);
      setNoteList([
        {
          note: row?.note,
          interaction: row?.interaction,
          added_by: row?.added_by,
        },
      ]);
    }
  };

  const fetchNotesTableList = async (jobId) => {
    setNotesTableListLoading(true);
    const res = await GET(getDameNotes(jobId));
    if (res?.success) {
      setNotesTableList(res?.data);
      setNotesTableListLoading(false);
    }
  };

  const handleCreateNote = async () => {
    setAddNoteLoading(true);
    if (resumeId) {
      const payload = noteList;
      if (noteId) {
        const res = await PUT(updateDameNote(noteId), noteList[0]);
        if (res?.success) {
          setSnackbarState({
            open: true,
            severity: "success",
            message: res?.message,
          });
        } else {
        }
      } else {
        const res = await POST(addDameNotes(resumeId), payload);
        if (res?.success || res?.data?.success) {
          setSnackbarState({
            open: true,
            severity: "success",
            message: res?.message || res?.data?.message,
          });
        } else {
        }
      }
      setAddNoteLoading(false);
      fetchNotesTableList(resumeId);
      setOpenNoteDialog(false);
      setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
    }
  };

  const handleDeleteNoteById = async (row) => {
    const res = await DELETE(deleteDameNote(noteId));
    if (res?.success) {
      setSnackbarState({
        open: true,
        severity: "success",
        message: res?.message,
      });
      fetchNotesTableList(resumeId);
      setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
      setDeleteNoteDialogOpen(false);
      setNoteId("");
    } else {
    }
  };

  const fetchAttachmentTableList = async (resumeId) => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await AttachementTableGetCall(resumeId);
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchNotesTableList(resumeId);
    fetchAttachmentTableList(resumeId);
    fetchCalendlyEventTypes();
  }, [resumeId]);

  useEffect(() => {
    setEnableQuestion((prev) => ({
      ...prev,
      status:
        matchedData?.insights?.feedback?.enable_pre_screen_questions || false,
    }));
    setGetJustification((prev) => ({
      ...prev,
      title: matchedData?.spider_graph_results?.[0]?.justification,
      name: matchedData?.spider_graph_results?.[0]?.name,
      payload: matchedData?.spider_graph_results?.[0],
    }));
  }, [matchedData]);

  const handleNoteTextChange = (index, e) => {
    const newNoteList = [...noteList];
    newNoteList[index].note = e.target.value;
    setNoteList(newNoteList);
  };

  const handleDownloadResume = () => {
    if (resumeId) {
      // setDownloadMenuLoader(true);
      setMenuLoading((prev) => ({
        ...prev,
        disabled: true,
        downloadMenuLoader: true,
      }));
      GETDOWNLOAD(DownloadResume(resumeId), {
        params: { type: "match_resume" },
        responseType: "blob",
      })
        .then((response) => {
          const contentType = response.headers["content-type"];

          const fileName = `${matchedData?.file_name}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          setMenuLoading((prev) => ({
            ...prev,
            disabled: false,
            downloadMenuLoader: false,
          }));
          // setDownloadMenuLoader(false);
        })
        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
          // setDownloadMenuLoader(false);
          setMenuLoading((prev) => ({
            ...prev,
            disabled: false,
            downloadMenuLoader: false,
          }));
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Resume was not parsed successfully. Unable to download.",
      });
      // setDownloadMenuLoader(false);
      setMenuLoading((prev) => ({
        ...prev,
        disabled: false,
        downloadMenuLoader: false,
      }));
    }
  };

  const handleInteractionAction = (data) => {
    setInterAction({ data: data, open: true });
  };

  const handleScoreChange = async (label) => {
    setMatchSelected((prev) => ({
      ...prev,
      loading: true,
      disabled: true,
      name: label,
    }));
    await fetchResumeData(resumeId, queryValue - 2, "", { spider_key: label });
    setMatchSelected((prev) => ({ ...prev, disabled: false, loading: false }));
  };

  const handleDuplicate = async (action) => {
    let params = {
      action: action,
      match_resume_id: matchedData.id,
      resume_id: matchedData.resume_id,
    };
    setViewResume((prev) => ({
      ...prev,
      disabled: true,
      duplicateLoading: action === "duplicate" ? true : false,
      replacedLoading: action === "replaced" ? true : false,
    }));
    try {
      const data = await JobResumeDuplicate(params);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data?.message,
      });
      handleViewCandidateClose();
      navigate(`/candidates/candidate-view?view-id=${data?.data?.id}`);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setViewResume((prev) => ({
        ...prev,
        disabled: false,
        duplicateLoading: false,
        replacedLoading: false,
      }));
    }
  };

  const FooterViewResume = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Duplicate"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={viewResume.disabled}
        loading={viewResume.duplicateLoading}
        onClick={() => handleDuplicate("duplicate")}
      />
      <CommonButton
        value={"Replace Existing"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={viewResume.disabled}
        loading={viewResume.replacedLoading}
        onClick={() => handleDuplicate("replaced")}
      />
    </CommonGrid2>
  );

  const handleViewCandidateClose = () => {
    setViewResume({
      open: false,
      disabled: false,
      duplicateLoading: false,
      replacedLoading: false,
    });
  };

  const handleViewCandidate = () => {
    setViewResume((prev) => ({
      ...prev,
      open: true,
      disabled: false,
      duplicateLoading: false,
      replacedLoading: false,
    }));
  };

  const handleView = async () => {
    setMenuViewLoader(true);
    let params = {
      match_resume_id: matchedData.id,
      resume_id: matchedData.resume_id,
    };

    try {
      const data = await JobResumeDuplicate(params);
      fetchResumeData(resumeId, queryValue - 2, "", "");
      setSnackbarState({
        open: true,
        severity: "success",
        message: data?.message,
      });

      // navigate(`/candidates/candidate-view?view-id=${data?.data?.id}`);
      setMenuViewLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setMenuViewLoader(false);
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen({ open: false, loading: false });
  };

  const handleShareInvite = async (shareData) => {
    setShareDialogOpen((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let payload = {
        url: window.location.href,
        to_mail: shareData.map((item) => item.email),
        cc_mail: [],
      };
      const data = await JobJobShare(payload, "jobResume");
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleShareDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setShareDialogOpen((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleShareClick = () => {
    setShareDialogOpen({ open: true, loading: false });
  };

  const handleRequestInfo = async () => {
    setIsRequestLoading(true);
    const url = process.env.REACT_APP_URL;

    try {
      const payload = {
        url: `${url}/coversheet?id=${resumeId}`,
        match_resume_id: resumeId,
      };
      const response = await POST(shareCoverSheet(), payload);
      fetchResumeData(resumeId, queryValue - 2, "", "");
      setSnackbarState({
        open: true,
        message: response.message || "Request successful!",
        severity: "success",
      });
      setIsRequestLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message || "Request failed!",
        severity: "error",
      });
      setIsRequestLoading(false);
    }
  };

  const handleChangeStatus = async (e) => {
    setStatusDialog((prev) => ({
      ...prev,
      open: true,
      value: e.target.value,
    }));
  };

  const handleStatusChange = async (condition) => {
    if (condition === "no") {
      setStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleStatusClose();
      }, 1000);
    } else if (condition === "yes") {
      try {
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: true,
          disabled: true,
        }));

        setCandidateProfileValue(statusDialog.value);
        let params = {
          status: statusDialog.value,
        };
        let data = await StatusChange(resumeId, params);

        if (statusDialog.value === "Selected") {
          setStatusDialog((prev) => ({
            ...prev,
            open: false,
            hiredOpen: true,
            disabled: false,
            yesLoading: false,
            hiredData: data?.message,
          }));
        } else {
          await fetchData();
          handleStatusClose();
        }
      } catch (error) {
        setSnackbarState({
          open: true,
          message: error.message || "Request failed!",
          severity: "error",
        });
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    } else if (condition === "hired") {
      setStatusDialog((prev) => ({
        ...prev,
        hiredLoading: true,
      }));
      setTimeout(() => {
        setStatusDialog((prev) => ({
          ...prev,
          hiredLoading: false,
        }));
        handleStatusClose();
        navigate("/jobs");
      }, 1000);
    }
  };

  const SatusFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={statusDialog.disabled}
        loading={statusDialog.noLoading}
        onClick={() => handleStatusChange("no")}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={statusDialog.disabled}
        loading={statusDialog.yesLoading}
        onClick={() => handleStatusChange("yes")}
      />
    </CommonGrid2>
  );

  const handleStatusClose = () => {
    setStatusDialog((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
    }));
  };

  const handleAttachment = () => {
    setAttachmentDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAttachmentClose = () => {
    setAttachmentDialog({
      loading: false,
      disabled: false,
      open: false,
    });
  };

  const handleAttachmentSubmit = async (values, { setFieldValue }) => {
    try {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: false,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: true,
        disabled: true,
      }));

      const formData = new FormData();

      values.file.forEach((fileObj) => {
        formData.append("file", fileObj.file);
      });
      formData.append("name", values.name);
      const data = await AttachementCreateCall(resumeId, formData);
      await fetchAttachmentTableList(resumeId);
      handleAttachmentClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: true,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleIconClick = (event, rowData, index) => {
    setAttachementRowData(rowData);
    setAnchorEl(event.currentTarget);
    setAttachementMenuLoader((prev) => ({
      ...prev,
      delete: index === 0 ? true : false,
    }));
    setAttachmentOpen(index);
  };

  const handleAttachmentMenuView = (row) => {
    if (row.name === "Assessment Test Transcript") {
      navigate(
        `/jobs/jobs-view/interview-kit?title=${title}&id=${jobId}&value=${queryValue}&match-id=${matchId}&candidate-name=${candidateName}`
      );
    } else if (row.name === "References") {
      if (row.status === "Pending") {
        navigate(
          `/jobs/jobs-view/reference-check?title=${title}&id=${jobId}&value=${queryValue}&match-id=${matchId}&candidate-name=${candidateName}`
        );
      } else {
        navigate(
          `/jobs/jobs-view/reference-check-view?title=${title}&id=${jobId}&value=${queryValue}&match-id=${matchId}&candidate-name=${candidateName}`
        );
      }
    }
  };

  const handleAttachmentTableBodyData = (row, index) => (
    <>
      <TableCell>
        <CommonGrid2
          display={"flex"}
          gap={"5px"}
          alignItems={"center"}
          flexWrap={"wrap"}
        >
          {row.name || "-"}
          <CommonGrid2 display={"flex"} gap={"5px"} flexWrap={"wrap"}>
            {row.is_scored && (
              <CommonGrid2
                background={"#D1EFFF"}
                width="max-content"
                padding="2px 8px 2px 5px"
                color={"#344054"}
                fontSize="12px"
                fontWeight={700}
                borderRadius="50px"
                display={"flex"}
                alignItems="center"
                gap={"5px"}
              >
                <AnomalyStarIco size={"12"} />
                Scored
              </CommonGrid2>
            )}
            {row.is_new && (
              <CommonGrid2
                background={"#ECFDF3"}
                width="max-content"
                padding="2px 8px 2px 5px"
                color={"#344054"}
                fontSize="12px"
                fontWeight={700}
                borderRadius="50px"
                display={"flex"}
                alignItems="center"
                gap={"5px"}
              >
                <AnomalyTickIco size={"12"} />
                Active
              </CommonGrid2>
            )}
          </CommonGrid2>
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>
        {/* {row.status || "-"} */}
        {row.status === null ? (
          "-"
        ) : (
          <Fragment>
            <CommonGrid2
              border="1px solid #D0D5DD"
              display="flex"
              alignItems="center"
              borderRadius="5px"
              padding="2px 5px"
              gap="5px"
              width={"max-content"}
              boxShadow="0px 0px 1px 0px #101828"
              fontSize="13px"
            >
              <DotColor color={row.status === "Pending" ? "red" : "green"} />
              {row.status}
            </CommonGrid2>
          </Fragment>
        )}
      </TableCell>
      <TableCell>{row.created_by || "-"}</TableCell>
      <TableCell>
        {moment(row.created_at).format("DD MMM YYYY") || "-"}
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => handleIconClick(e, row, index)}
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={anchorEl}
          open={attachementOpen === index}
          onClose={() => {
            setAnchorEl(null);
            setAttachmentOpen(null);
          }}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {row.name === "Assessment Test Transcript" ||
          row.name === "References" ? (
            <MenuItem
              onClick={() => {
                handleAttachmentMenuView(row);
              }}
            >
              <StyledFlexRowView>
                <EyeIco />
                <Typography>View</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ) : (
            <>
              {attachmentMenuData.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={item.disabled ? () => {} : item.onClick}
                  aria-controls={item.ariaControls}
                  aria-haspopup={item.ariaHasPopup}
                  aria-expanded={item.ariaExpanded}
                  style={{ opacity: item.disabled ? 0.5 : 1 }}
                  disabled={item?.disabled}
                >
                  <StyledFlexRowView>
                    {item.image}
                    <Typography>{item.title}</Typography>
                  </StyledFlexRowView>
                </MenuItem>
              ))}
            </>
          )}
        </CustomizeMenu>
      </TableCell>
    </>
  );

  const handelAttachmentDialogClose = () => {
    setDeleteButton({
      loading: false,
      open: false,
      content: "",
      id: "",
    });
  };

  const EnableFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={enableQuestion.disabled}
        loading={enableQuestion.leaveLoading}
        onClick={() => handleEnableQuestion("Leave")}
      />
      <CommonButton
        value={"Confirm"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={enableQuestion.disabled}
        loading={enableQuestion.confirmLoading}
        onClick={() => handleEnableQuestion("Confirm")}
      />
    </CommonGrid2>
  );

  const handleQuestionEnable = async (event) => {
    setEnableQuestion((prev) => ({
      ...prev,
      open: true,
      status: event.target.checked,
      content:
        event.target.checked === true
          ? "Enabling this will include these questions in the candidate's coversheet. Do you want to proceed?"
          : "Do you want to disable these questions",
    }));
  };

  const handleEnableQuestion = async (condition) => {
    if (condition === "Leave") {
      setEnableQuestion((prev) => ({
        ...prev,
        leaveLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleEnableQuestionClose();
      }, 1000);
    } else if (condition === "Confirm") {
      try {
        setEnableQuestion((prev) => ({
          ...prev,
          confirmLoading: true,
          disabled: true,
        }));
        let payload = {
          id: resumeId,
          status: enableQuestion.status,
          pre_screen_questions_red_flags:
            matchedData?.insights?.feedback?.pre_screen_questions_red_flags,
        };
        const data = await JobCandidateQueationEnable(payload);
        await fetchResumeData(resumeId, queryValue - 2, "");
        handleEnableQuestionClose();
        setSnackbarState({
          open: true,
          message: data.message,
          severity: "success",
        });
      } catch (error) {
        setEnableQuestion((prev) => ({
          ...prev,
          confirmLoading: false,
          disabled: false,
        }));
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    }
  };

  const handleEnableQuestionClose = () => {
    setEnableQuestion({
      open: false,
      status: matchedData?.insights?.feedback?.enable_pre_screen_questions,
      disabled: false,
      confirmLoading: false,
      leaveLoading: false,
      content: "",
    });
  };

  const handleCopyMouseLeave = () => {
    setTimeout(() => setCopied(false), 200);
  };

  const handleCopyClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (error) {}
  };

  const handleEditCandidate = () => {
    setEditDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleEditCandidateClose = () => {
    setEditDialog({
      open: false,
      disabled: false,
      cancelLoading: false,
      saveLoading: false,
    });
  };

  const handleEditCandidateCloseBtn = () => {
    setEditDialog((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleEditCandidateClose();
    }, 1000);
  };

  const handleEditCandidateSubmit = async (values, initialValues) => {
    try {
      const payload = {
        candidate_name: {
          old_value: initialValues.candidate_name,
          new_value: values.candidate_name,
        },
        email: {
          old_value: initialValues.email,
          new_value: values.email,
        },
        phone_number:{
          old_value: initialValues.phone_number,
          new_value: values.phone_number,
        },
        location: {
          old_value: initialValues.location,
          new_value: values.location,
        },
        title: {
          old_value: initialValues.title,
          new_value: values.title,
        },
        pay_rate: {
          new_value: {
            min: values.min.toString(),
            max: values.max.toString(),
            currency: values.rate,
          },
          old_value: {
            min: initialValues.min.toString(),
            max: initialValues.max.toString(),
            currency: initialValues.rate,
          },
        },
        live_screening_score: {
          old_value: initialValues.live_screening_score,
          new_value: values.live_screening_score,
        },
        willing_to_relocate: {
          old_value: initialValues.willing_to_relocate,
          new_value: values.willing_to_relocate,
        },
        notice_period: {
          old_value: initialValues.notice_period?.toString() ?? "",
          new_value: values.notice_period?.toString() ?? "",
        },
        visa_status: {
          old_value: initialValues.visa_status,
          new_value: values.visa_status,
        },
        country: values.country,
      };
      setEditDialog((prev) => ({
        ...prev,
        disabled: true,
        saveLoading: true,
      }));
      let data = await JobEditCandidate(resumeId, payload);
      await fetchData();
      handleEditCandidateClose();
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setEditDialog((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        saveLoading: false,
      }));
    }
  };

  useEffect(() => {
    if (JobRescore && JobRescore?.[jobId]?.status === "success") {
      handleRescoreClose();
    }
  }, [JobRescore]);

  const WholeProgressView = () => {
    return (
      <CommonGrid2 margin={"1.5rem 0px 1rem"}>
        {JobRescore &&
          JobRescore[jobId]?.data &&
          JobRescore[jobId]?.data?.map((file, index) => (
            <FileContainer
              key={index}
              elevation={1}
              gap={"1rem"}
              padding={"6px 10px 3px"}
              margin="16px 0px 0px"
              borderRadius="7px"
            >
              <Box display={"flex"} alignItems={"flex-start"} width={"20px"}>
                <GetFileIcon file={file} />
              </Box>

              <Box width={"100%"}>
                <CommonGrid2 display={"flex"} alignItems={"center"} gap={"5px"}>
                  <Typography
                    color="#344054"
                    fontSize={"14px"}
                    fontWeight={700}
                    textAlign={"start"}
                  >
                    {file.title}
                  </Typography>
                  {/* <CustomizeSpan
                    background={
                      file.record_type === "GOLDEN RECORD"
                        ? "#DAFDF5"
                        : "#F7F1FF"
                    }
                    width="max-content"
                    border={
                      file.record_type === "GOLDEN RECORD"
                        ? "1px solid #C3FFF1"
                        : "1px solid #EAECF0"
                    }
                    padding="2px 10px"
                    color={
                      file.record_type === "GOLDEN RECORD"
                        ? "#049F9A"
                        : "#6941C6"
                    }
                    fontSize="11px"
                    fontWeight={700}
                    borderRadius="50px"
                  >
                    {file.record_type
                      ?.toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                  </CustomizeSpan> */}
                </CommonGrid2>

                <Typography color="#475467" fontSize={"14px"} fontWeight={500}>
                  {file.size}
                </Typography>
                {file.progress >= 0 && (
                  <CommonTippy
                    content={file.message}
                    visible={file.visible}
                    interactive={true}
                    trigger="click"
                    hideOnClick={false}
                    zIndex={2}
                    color="red"
                  >
                    <CustomDiv textAlign="left">
                      <StyledLinearContainer>
                        <CommonLinearProgress
                          variant={
                            file.progress && !file.visible
                              ? "buffer"
                              : "determinate"
                          }
                          value={file.progress}
                          valueBuffer={file.buffer}
                          height={"6px"}
                          left="0px"
                          borderRadius={"2px"}
                          backgroundColor={"#E0E0E0"}
                          barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                          dashedmarginTop={"1px"}
                          dashedbackgroundImage={
                            file.visible
                              ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                              : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                          }
                        />

                        <Typography
                          color="#344054"
                          fontSize={"14px"}
                          fontWeight={500}
                        >
                          {file.progress}%
                        </Typography>
                      </StyledLinearContainer>
                      {file.progress_message && (
                        <CustomizeSpan
                          fontSize="12px"
                          color="#475467"
                          sx={{
                            letterSpacing: "0.2px",
                            animation: "wave 1.5s ease-in-out infinite",
                            "@keyframes wave": {
                              "0%, 100%": { transform: "translateY(0)" },
                              "50%": { transform: "translateY(-4px)" },
                            },
                          }}
                        >
                          {file.progress_message} . . .
                        </CustomizeSpan>
                      )}
                    </CustomDiv>
                  </CommonTippy>
                )}
              </Box>
            </FileContainer>
          ))}
      </CommonGrid2>
    );
  };

  const rescoreContent = () => {
    return (
      <CommonGrid2>
        <Typography
          variant="h3"
          textAlign={"center"}
          color="#101828"
          fontSize={"18px"}
        >
          Rescore Candidates
        </Typography>
        {WholeProgressView()}
      </CommonGrid2>
    );
  };

  const handleClickScoreConfirmation = async (condition) => {
    if (condition === "no") {
      setReScore((prev) => ({
        ...prev,
        disabled: true,
        noLoading: true,
      }));
      setTimeout(() => {
        dispatch(JobJobRescore({ id: jobId, data: [], status: "fail" }));
        handleRescoreClose();
      }, 1000);
    } else {
      setReScore((prev) => ({
        ...prev,
        disabled: true,
        yesLoading: true,
      }));
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      // const checkData = [
      //   ...jobData?.hiring_manager,
      //   ...jobData?.golden_record,
      // ].map((item) => ({
      //   title: item.name,
      //   value: true,
      //   progress: 0,
      //   buffer: 0,
      //   record_type: item.record_type,
      //   type: item.file_name,
      //   name: item.file_name,
      //   visible: false,
      // }));
      const fileData = [
        // ...checkData,
        {
          title: matchedData.name,
          value: true,
          progress: 0,
          buffer: 0,
          type: matchedData.resume_file_name,
          name: matchedData.resume_file_name,
          visible: false,
        },
      ];
      const updated = {
        ...existing,
        [jobId]: {
          ...existing[jobId],
          data: fileData,
          status: "process",
        },
      };

      localStorage.setItem("JobRescore", JSON.stringify(updated));
      dispatch(
        JobJobRescore({
          id: jobId,
          data: updated[jobId].data,
          status: "process",
        })
      );
      let params = {
        score: true,
      };

      const getDataId = [
        ...jobData?.hiring_manager,
        ...jobData?.golden_record,
      ].map((item) => ({
        id: item.id,
      }));
      let payload = {
        job: false,
        resumes: [...getDataId, { id: matchedData.id }],
      };

      try {
        const response = await JobJobReScore(jobId, params, payload);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;

          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse, condition);
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("JobRescore")
              )?.[jobId];
              const getData = storedData?.data?.map((f) =>
                f.title === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      message: e.message,
                    }
                  : { ...f }
              );

              const existing =
                JSON.parse(localStorage.getItem("JobRescore")) || {};
              localStorage.setItem(
                "JobRescore",
                JSON.stringify({
                  ...existing,
                  [jobId]: {
                    data: getData,
                    status: "",
                  },
                })
              );

              dispatch(
                JobJobRescore({ id: jobId, data: getData, status: "fail" })
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setReScore({
                noLoading: false,
                disabled: false,
                yesLoading: false,
                open: true,
              });
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse, condition);
          } catch (e) {
            const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
              jobId
            ];
            const getData = storedData?.data?.map((f) =>
              f.title === jsonResponse.data.current_resume
                ? {
                    ...f,
                    visible: true,
                    delete: true,
                    message: e.message,
                  }
                : { ...f, delete: true, message: e.message }
            );

            const existing =
              JSON.parse(localStorage.getItem("JobRescore")) || {};
            localStorage.setItem(
              "JobRescore",
              JSON.stringify({
                ...existing,
                [jobId]: {
                  data: getData,
                  status: "",
                },
              })
            );

            dispatch(
              JobJobRescore({ id: jobId, data: getData, status: "fail" })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setReScore({
              noLoading: false,
              disabled: false,
              yesLoading: false,
              open: true,
            });
          }
        }
      } catch (error) {
        const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
          jobId
        ];
        const getData = storedData?.data?.map((f) => ({
          ...f,
          visible: true,
          message: "Error during the request",
        }));
        const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
        localStorage.setItem(
          "JobRescore",
          JSON.stringify({
            ...existing,
            [jobId]: {
              data: getData,
              status: "",
            },
          })
        );

        dispatch(JobJobRescore({ id: jobId, data: getData, status: "fail" }));

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });

        setReScore({
          noLoading: false,
          disabled: false,
          yesLoading: false,
          open: true,
        });
      }
    }
  };

  const processJsonResponse = async (jsonResponse, condition) => {
    const { success, data, message } = jsonResponse;

    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        jobId
      ];
      const getData = storedData?.data?.map((f) =>
        f.title === data.current_resume
          ? {
              ...f,
              progress: data.percent,
              buffer: data.percent,
              visible: false,
              progress_message: data.progress_message,
            }
          : f
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: getData,
            status: "process",
          },
        })
      );
      dispatch(JobJobRescore({ id: jobId, data: getData, status: "process" }));
    } else if (data?.response) {
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: [],
            status: "success",
          },
        })
      );
      // await fetchResumeData(resumeId, queryValue - 2, "", {});
      await fetchData();
      fetchAttachmentTableList(resumeId);
      dispatch(JobJobRescore({ id: jobId, data: [], status: "success" }));
      handleRescoreClose();

      setSnackbarState({
        open: true,
        severity: "success",
        message: message,
        // duration: 500,
      });
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        jobId
      ];
      const getData = storedData?.data?.map((f) =>
        f.title === data.current_resume || data.length === 0
          ? {
              ...f,
              visible: true,
              message: message,
            }
          : { ...f, delete: true }
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: getData,
            status: "",
          },
        })
      );

      dispatch(JobJobRescore({ id: jobId, data: getData, status: "fail" }));

      setReScore({
        noLoading: false,
        disabled: false,
        yesLoading: false,
        open: true,
      });
    }
  };

  const ConfirmationButton = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"} marginTop={"2rem"}>
        <CommonButton
          value={"Cancel"}
          variant="outlined"
          color="#344054"
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          border={"#D0D5DD"}
          onClick={() => handleClickScoreConfirmation("no")}
          disabled={reScore.disabled}
          loading={reScore.noLoading}
        />

        <CommonButton
          value={"Yes"}
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={reScore.disabled}
          loading={reScore.yesLoading}
          onClick={() => handleClickScoreConfirmation("yes")}
        />
      </CommonGrid2>
    );
  };

  const handleRescoreClose = () => {
    setReScore({
      noLoading: false,
      disabled: false,
      yesLoading: false,
      open: false,
    });
  };

  const handleRescoreCandidate = () => {
    const rescoreData = JobRescore && JobRescore?.[jobId];
    if (
      rescoreData &&
      rescoreData?.status !== "success" &&
      rescoreData?.status !== "fail"
    ) {
      setReScore((prev) => ({
        ...prev,
        open: true,
        noLoading: false,
        disabled: true,
        yesLoading: true,
      }));
    } else {
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      // const checkData = [
      //   ...jobData?.hiring_manager,
      //   ...jobData?.golden_record,
      // ].map((item) => ({
      //   title: item.name,
      //   value: true,
      //   progress: 0,
      //   buffer: 0,
      //   record_type: item.record_type,
      //   type: item.file_name,
      //   name: item.file_name,
      //   visible: false,
      // }));
      const fileData = [
        // ...checkData,
        {
          title: matchedData.name,
          record_type: matchedData.record_type,
          value: true,
          progress: 0,
          buffer: 0,
          type: matchedData.resume_file_name,
          name: matchedData.resume_file_name,
          visible: false,
        },
      ];
      console.log(fileData, "fileData");

      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [jobId]: {
            data: fileData,
            status: "",
          },
        })
      );
      dispatch(JobJobRescore({ id: jobId, data: fileData, status: "fail" }));

      setReScore((prev) => ({
        ...prev,
        open: true,
      }));
    }
  };

  const handleTableBodyData = (row) => {
    return (
      <>
        <StyledTableBodyTableCell>{row.order_no}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.created_by}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.type}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.action}</StyledTableBodyTableCell>
        <TableCell>
          <CommonGrid2
            display={"flex"}
            border="1px solid #D0D5DD"
            color="#344054"
            width="max-content"
            alignItems="center"
            borderRadius="5px"
            padding="2px 5px"
            gap="5px"
            boxShadow="0px 0px 1px 0px #101828"
            fontSize="13px"
          >
            <DotColor color={"green"} />
            {row.status}
          </CommonGrid2>
        </TableCell>
        <StyledTableBodyTableCell>{row.created_at}</StyledTableBodyTableCell>

        <TableCell>
          {row.updated_fields.length !== 0 && (
            <IconButton
              onClick={() => {
                handleInteractionAction(row);
              }}
            >
              <EyeIco />
            </IconButton>
          )}
        </TableCell>
      </>
    );
  };

  const handleReferenceClick = async () => {
    try {
      setMenuLoading((prev) => ({
        ...prev,
        disabled: true,
        referenceLoading: true,
      }));
      let payload = {
        match_id: matchId,
      };
      const data = await ReferenceShareClick(payload);
      console.log(data, "sfskjfnsjfsnfsfnjkkj");
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      setMenuLoading((prev) => ({
        ...prev,
        disabled: false,
        referenceLoading: false,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setMenuLoading((prev) => ({
        ...prev,
        disabled: false,
        referenceLoading: false,
      }));
    }
  };

  const menuItems = [
    {
      label: "Share",
      icon: <ShareIco />,
      onClick: () => {
        handleShareClick();
        handleCloseDot();
      },
      disabled:
        menuLoading.disabled ||
        matchedData?.status === "Rejected" ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
    },
    {
      label: "Compare",
      icon: <CalenderIco />,
      onClick: handleClickCompare,
      ariaControls: openDot ? "basic-menu" : undefined,
      ariaHasPopup: "true",
      ariaExpanded: openDot ? "true" : undefined,
      disabled:
        menuLoading.disabled ||
        matchedData?.status === "Rejected" ||
        filteredResumeTab.length === 0 ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
    },
    {
      label: "Add Note",
      icon: <ClipBoardCheck />,
      disabled:
        menuLoading.disabled ||
        matchedData?.status === "Rejected" ||
        // !matchedData?.rice_created ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleClickAddNote();
        handleCloseDot();
      },
    },
    {
      label: "Download",
      disabled: menuLoading.disabled,
      icon: menuLoading.downloadMenuLoader ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "16px" }} />
      ),
      onClick: handleDownloadResume,
    },
    {
      label: "Edit Profile",
      icon: <EditTwoToneIcon sx={{ fontSize: "16px" }} />,
      disabled:
        menuLoading.disabled ||
        matchedData?.status === "Rejected" ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleEditCandidate();
        handleCloseDot();
      },
    },
    {
      label: "Rescore",
      icon: <RescoreMenuItemIco />,
      disabled:
        menuLoading.disabled ||
        matchedData?.status === "Rejected" ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleRescoreCandidate();
        handleCloseDot();
      },
    },

    ...(matchedData?.temp_rice_created
      ? [
          {
            label: matchedData?.rice_created
              ? "View Profile"
              : "Save to Candidate Hub",

            icon: menuViewLoader ? (
              <CircularProgress
                size={20}
                thickness={5}
                style={{ color: "#667085" }}
              />
            ) : (
              <EyeIco size={"16px"} />
            ),
            disabled:
              menuLoading.disabled ||
              matchedData?.status === "Rejected" ||
              menuViewLoader ||
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
            onClick: async () => {
              if (matchedData?.rice_created) {
                navigate(
                  `/candidates/candidate-view?view-id=${matchedData.resume_id}`
                );
              } else if (matchedData?.duplication_present) {
                handleCloseDot();
                handleViewCandidate();
              } else {
                await handleView();
                handleCloseDot();
              }
            },
          },
        ]
      : []),

    ...(matchedData?.coversheet_submitted === true
      ? [
          {
            label: "Cover Sheet",
            icon: <ClipBoardCheck />,
            disabled:
              menuLoading.disabled ||
              matchedData?.status === "Rejected" ||
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
            onClick: () =>
              navigate(`/coversheet?id=${resumeId}&view_resume=true`),
          },
          {
            label: (
              <>
                Generate Submission
                <br />
                Document
              </>
            ),
            disabled:
              matchedData?.show_submission_document ||
              menuLoading.disabled ||
              matchedData?.status === "Rejected" ||
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
            icon: menuLoading.submissionLoading ? (
              <CircularProgress
                size={20}
                thickness={5}
                style={{ color: "#667085" }}
              />
            ) : (
              <DescriptionIcon sx={{ fontSize: "16px" }} />
            ),
            onClick: async () => {
              const additionalParams = {
                title: query.get("title") || "",
                value: query.get("value") || "",
                "match-id": matchedData.id || "",
                document:
                  matchedData?.submission_document_created?.toString() || "",
                id: query.get("id") || "",
              };

              const url = buildUrl(
                `${process.env.REACT_APP_URL}/jobs/submission`,
                additionalParams,
                getBreadcrumb
              );

              const submissionPayload = {
                job_title: query.get("title") || "",
                candidate_name: matchedData?.name,
                job_id: query.get("id") || "",
                submission_document_url: url,
              };
              setMenuLoading((prev) => ({
                ...prev,
                disabled: true,
                submissionLoading: true,
              }));
              const data = await CreateSubmissionDocument(
                matchedData.id,
                submissionPayload
              );
              if (data?.status === 200) {
                setSnackbarState({
                  open: true,
                  message: "Submission document created successfully",
                  severity: "success",
                });
              } else {
                setSnackbarState({
                  open: true,
                  message: data?.message,
                  severity: "error",
                });
              }
              setMenuLoading((prev) => ({
                ...prev,
                disabled: false,
                submissionLoading: false,
              }));

              // navigate(url);
              handleCloseDot();
            },
          },
          {
            label: "Reference",
            icon: menuLoading.referenceLoading ? (
              <CircularProgress
                size={20}
                thickness={5}
                style={{ color: "#667085" }}
              />
            ) : (
              <ShareIco />
            ),
            onClick: handleReferenceClick,
            disabled:
              menuLoading.disabled ||
              matchedData?.status === "Rejected" ||
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
          },
        ]
      : []),
  ];

  const CustomMenuItem = (item, index) => (
    <MenuItem key={index} value={item.id}>
      {item.name}
    </MenuItem>
  );

  const handleCompareNavigate = (item) => {
    const urlParams = new URLSearchParams();
    urlParams.append("title", query.get("title") || "");
    urlParams.append("value", query.get("value") || "");
    urlParams.append("id", query.get("id") || "");
    urlParams.append("match-id", resumeId);

    if (
      getBreadcrumb &&
      getBreadcrumb !== null &&
      getBreadcrumb !== "null" &&
      getBreadcrumb !== "undefined"
    ) {
      urlParams.append("breadcrumbs", getBreadcrumb);
    }

    const path = `/jobs/candidate/compare/${resumeId}/${
      item?.id
    }?${urlParams.toString()}`;

    navigate(path);
  };

  const CustomTooltip = ({ active, payload }) => {
    React.useEffect(() => {
      if (active && payload && payload.length) {
        const { name, justification } = payload[0].payload;

        setGetJustification({
          name,
          title: justification,
          payload: payload[0].payload,
        });
      }
    }, [active, payload, setGetJustification]);

    if (active && payload && payload.length) {
      const { name, candidate_score, highest_score, average_score } =
        payload[0].payload;
      return (
        <Box
          backgroundColor={"rgb(249 247 255)"}
          padding={"10px"}
          border={"1px solid rgb(127, 86, 217)"}
          borderRadius={"5px"}
        >
          <TooltipParagraph
            textAlign="center"
            fontWeight={700}
            fontSize="13px"
            color="#000"
          >
            {name}
          </TooltipParagraph>
          <CommonGrid2
            gap="4px"
            marginTop="8px"
            display="flex"
            flexDirection="column"
          >
            <TooltipParagraph
              color="#6941C6"
              display="flex"
              justifyContent="space-between"
              fontSize="12px"
            >
              Candidate Score:{" "}
              <TooltipParagraph fontWeight={700}>
                {candidate_score}
              </TooltipParagraph>
            </TooltipParagraph>
            <TooltipParagraph
              color="#667085a1"
              display="flex"
              justifyContent="space-between"
              fontSize="12px"
            >
              Highest Score:{" "}
              <TooltipParagraph fontWeight={700}>
                {highest_score}
              </TooltipParagraph>
            </TooltipParagraph>
            <TooltipParagraph
              color="#F79009"
              display="flex"
              justifyContent="space-between"
              fontSize="12px"
            >
              Average Score:{" "}
              <TooltipParagraph fontWeight={700}>
                {average_score}
              </TooltipParagraph>
            </TooltipParagraph>
          </CommonGrid2>
        </Box>
      );
    }
    return null;
  };

  const handleChangeAccor = (panel) => (_, isExpanded) => {
    setExpandedPanel((prev) =>
      isExpanded ? [...prev, panel] : prev.filter((p) => p !== panel)
    );
  };

  const handlePreScreenQuestionEdit = () => {
    setPreScreen((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleDialogClose = () => {
    setPreScreen((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      saveLoading: false,
    }));
  };

  const handlePreScreenSubmit = async (values) => {
    try {
      setPreScreen((prev) => ({
        ...prev,
        saveLoading: true,
        disabled: true,
      }));

      let payload = {
        id: resumeId,
        status: enableQuestion.status,
        pre_screen_questions_red_flags: values.questions,
      };
      const data = await JobCandidateQueationEnable(payload);
      await fetchResumeData(resumeId, queryValue - 2, "");
      handleDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setPreScreen((prev) => ({
        ...prev,
        saveLoading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleReview = () => {
    setReview((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleReviewClose = () => {
    setReview((prev) => ({
      ...prev,
      open: false,
      markLoading: false,
      disabled: false,
    }));
  };

  const negative_flag =
    matchedData?.insights?.feedback?.red_flags?.filter(
      (item) => item.type === "negative"
    ) || [];

  const handleMarkAsReviewed = async () => {
    setReview((prev) => ({
      ...prev,
      disabled: true,
      markLoading: true,
    }));
    try {
      let payload = {
        id: resumeId,
        status: enableQuestion.status,
        pre_screen_questions_red_flags:
          matchedData?.insights?.feedback?.pre_screen_questions_red_flags,
        is_red_flags_reviewed: true,
      };
      const data = await JobCandidateQueationEnable(payload);
      await fetchResumeData(resumeId, queryValue - 2, "");
      handleReviewClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      handleReviewClose();
    }
  };
  return (
    <Grid2 container spacing={4} ref={ref}>
      <Grid2 size={12}>
        <ProfileInformation
          matchedData={matchedData}
          loading={resumeLoader}
          isRequestLoading={isRequestLoading}
          handleRequestInfo={handleRequestInfo}
          candidateProfileValue={candidateProfileValue}
          handleChangeStatus={handleChangeStatus}
          handleCopyMouseLeave={handleCopyMouseLeave}
          handleCopyClick={handleCopyClick}
          copied={copied}
          statusOptions={statusOptions}
          menuItems={menuItems}
          CustomMenuItem={CustomMenuItem}
          dotAnchorEl={dotAnchorEl}
          anchorElCompare={anchorElCompare}
          handleCloseCompare={handleCloseCompare}
          handleCompareNavigate={handleCompareNavigate}
          handleClickDot={handleClickDot}
          openCompare={openCompare}
          openDot={openDot}
          jobStatus={jobStatus}
          handleCloseDot={handleCloseDot}
          filteredResumeTab={filteredResumeTab}
          calendlyEvent={calendlyEvent}
          handleScheduleInterview={handleScheduleInterview}
          checkWidth={bounds.width}
        />
      </Grid2>

      <Grid2 size={12}>
        <Result
          matchedData={matchedData}
          loading={resumeLoader}
          handleQuestionMarkClick={handleQuestionMarkClick}
          iconVisible={iconVisible}
          chatBotData={chatBotData}
          handleReview={handleReview}
          negative_flag={negative_flag}
          checkWidth={bounds.width}
        />

        <Grid2 size={12} marginTop={"1rem"}>
          <CommonAccordion
            accordionButton={expandedPanel.includes("Basic Info")}
            title={"Basic Info"}
            icon={<BasicInfoIco />}
            open={expandedPanel.includes("Basic Info")}
            onChange={handleChangeAccor("Basic Info")}
            children={
              <BasicInfo
                section_1_data={section_1_data}
                loading={resumeLoader}
                handleCopyClick={handleCopyClick}
                handleCopyMouseLeave={handleCopyMouseLeave}
                copied={copied}
              />
            }
            CustomButton={
              <CommonButton
                variant="outlined"
                color="#344054"
                border="transparent"
                startIcon={<EditInfoIco />}
                fontWeight="600"
                value={"Edit"}
                gap={"0px"}
                padding="10px 16px"
                fullWidth
                disabled={matchedData?.status === "Rejected"}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditCandidate();
                }}
                svg={true}
                customStyle={{
                  pointerEvents: "all",
                  cursor: "pointer",
                }}
              />
            }
          />
        </Grid2>

        {!resumeLoader &&
          matchedData &&
          (Object.keys(matchedData?.probability_of_interview_info || {})
            ?.length !== 0 ||
            Object.keys(matchedData?.probability_of_hire_info || {})?.length !==
              0 ||
            Object.keys(matchedData?.start_flight_risk_info || {})?.length !==
              0) && (
            <Grid2 size={12} marginTop={"1rem"}>
              <CommonAccordion
                title={"Predictions"}
                icon={<Prediction />}
                children={
                  <CommonGrid2 container spacing={2}>
                    {Object.keys(
                      matchedData?.probability_of_interview_info || {}
                    )?.length !== 0 && (
                      <Predictions
                        name="Probability of Interview"
                        icon={<ProbabilityInterviewIco />}
                        data={matchedData?.probability_of_interview_info}
                        checkWidth={bounds.width}
                        handleQuestionMarkClick={handleQuestionMarkClick}
                        chatBotData={chatBotData}
                        value={"Probability of Interview"}
                      />
                    )}
                    {Object.keys(matchedData?.probability_of_hire_info || {})
                      ?.length !== 0 && (
                      <Predictions
                        name="Probability of Hire"
                        icon={<ProbabilityHire />}
                        data={matchedData?.probability_of_hire_info}
                        checkWidth={bounds.width}
                        handleQuestionMarkClick={handleQuestionMarkClick}
                        chatBotData={chatBotData}
                        value={"Probability of Hire"}
                      />
                    )}
                    {Object.keys(matchedData?.start_flight_risk_info || {})
                      ?.length !== 0 && (
                      <Predictions
                        name="Start / Flight Risk"
                        icon={<StarFlightico />}
                        data={matchedData?.start_flight_risk_info}
                        checkWidth={bounds.width}
                        handleQuestionMarkClick={handleQuestionMarkClick}
                        chatBotData={chatBotData}
                        value={"Start Flight Risk"}
                      />
                    )}
                  </CommonGrid2>
                }
              />
            </Grid2>
          )}

        <Grid2 size={12} marginTop={"1rem"}>
          {/* <Score
            data={matchedData?.insights?.match_analysis || ""}
            searchLoading={resumeLoader}
          /> */}
          <Grid2 size={12} marginTop={"1rem"}>
            <Summary
              matchedData={matchedData}
              loading={resumeLoader}
              handleQuestionMarkClick={handleQuestionMarkClick}
              iconVisible={iconVisible}
              chatBotData={chatBotData}
              checkWidth={bounds.width}
            />
          </Grid2>

          <SpiderGraph
            matchedData={matchedData}
            handleScoreChange={handleScoreChange}
            loading={matchSelected.loading ? false : resumeLoader}
            isLoading={resumeLoader}
            matchSelected={matchSelected}
            disabled={matchSelected.disabled ? matchSelected.disabled : false}
            handleQuestionEnable={handleQuestionEnable}
            enableQuestion={enableQuestion}
            getJustification={getJustification}
            CustomTooltip={CustomTooltip}
            checkWidth={bounds.width}
          />

          <PreScreenQuestions
            matchedData={matchedData}
            resumeLoader={resumeLoader}
            enableQuestion={enableQuestion}
            handleQuestionEnable={handleQuestionEnable}
            handlePreScreenQuestionEdit={handlePreScreenQuestionEdit}
          />
        </Grid2>
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          accordionButton={expandedPanel.includes("Experience")}
          icon={<ExperienceIco />}
          title={"Experience"}
          children={
            <Experience
              matchedData={matchedData?.experience}
              isLoading={resumeLoader}
              marginTop="10px"
            />
          }
        />
      </Grid2>
      <Grid2 size={12}>
        <CommonAccordion
          accordionButton={expandedPanel.includes("Notes")}
          icon={<AccordingNoteIco />}
          title={"Notes"}
          children={
            <Notes
              disabled={
                matchedData?.status === "Rejected" ||
                // !matchedData?.rice_created ||
                jobStatus === "Closed" ||
                jobStatus === "Cancelled" ||
                jobStatus === "Filled"
              }
              isShown={true}
              handleClickAddNote={handleClickAddNote}
              handleDeleteNoteClick={handleDeleteNote}
              handleUpdateNoteClick={handleUpdateNote}
              notesTableList={notesTableList}
              notesTableListLoading={notesTableListLoading || resumeLoader}
              isLoading={resumeLoader}
              headerData={noteHeaderData}
            />
          }
        />
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          disabled={
            jobStatus === "Closed" ||
            jobStatus === "Cancelled" ||
            jobStatus === "Filled"
          }
          accordionButton={true}
          buttonTitle={"Add Attachments"}
          icon={<AccordingAttachmentIco />}
          title={"Attachment"}
          CustomButton={
            <CommonButton
              fontWeight="600"
              value={"Add Attachment"}
              padding="8px 16px"
              fullWidth
              minWidth="auto"
              onClick={(e) => {
                e.stopPropagation();
                handleAttachment();
              }}
              svg={true}
              disabled={matchedData?.status === "Rejected"}
              customStyle={{
                pointerEvents: "all",
                cursor: "pointer",
              }}
            />
          }
          children={
            <Attachment
              visible={false}
              tableData={attachmentList?.data}
              attachementHeaderData={attachementHeaderData}
              handleAttachment={handleAttachment}
              handleAttachmentTableBodyData={handleAttachmentTableBodyData}
              isLoading={resumeLoader || attachmentList.loading}
              disabled={
                jobStatus === "Closed" ||
                jobStatus === "Cancelled" ||
                jobStatus === "Filled"
              }
              condition_based={condition_based}
            />
          }
        />
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          title={"Interactions"}
          children={
            <CommonTable
              marginTop={"0rem"}
              data={matchedData?.interactions}
              loading={resumeLoader}
              columns={interactionHeaderdata}
              handleTableBodyData={handleTableBodyData}
            />
          }
        />
      </Grid2>
      <InteractionDialog
        open={interAction.open}
        handleClose={() =>
          setInterAction((prev) => ({
            ...prev,
            open: false,
          }))
        }
        interActionData={interAction.data}
      />

      <DeleteNote
        deleteNoteDialogOpen={deleteNoteDialogOpen}
        handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
        noteList={noteList}
        handleDeleteNoteById={handleDeleteNoteById}
      />
      <AddUpdateNote
        openNoteDialog={openNoteDialog}
        handleCloseNoteDialog={handleCloseNoteDialog}
        id={noteId}
        handleCreateNote={handleCreateNote}
        noteList={noteList}
        handleNoteTextChange={handleNoteTextChange}
        addNoteLoading={addNoteLoading}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      <ShareQuickMatch
        title="Share Candidate Profile"
        shareDialogOpen={shareDialogOpen.open}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={shareDialogOpen.loading}
      />
      <EditCandidateProfile
        open={editDialog.open}
        editDialog={editDialog}
        matchedData={matchedData}
        handleClose={handleEditCandidateClose}
        handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
        handleSubmit={handleEditCandidateSubmit}
      />

      <DialogCandidateHub
        open={viewResume.open}
        handleClose={handleViewCandidateClose}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        footer={<FooterViewResume />}
        title="Candidate Already Exists"
        titlepadding={"0px 0px 16px"}
        content={
          <>
            You are about to save a candidate under the name{" "}
            <strong style={{ fontWeight: 700 }}>
              {matchedData?.candidate_name}
            </strong>{" "}
            and the role{" "}
            <strong style={{ fontWeight: 700 }}>
              {matchedData?.inferred_title}
            </strong>{" "}
            in the Candidate Hub.
          </>
        }
      />

      <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleStatusClose}
        footer={<SatusFooter />}
        title={"Do you want to confirm this"}
        titlepadding={"1rem 0px 0px"}
      />

      <DialogCandidateHub
        open={statusDialog.hiredOpen}
        closeIcon={false}
        footer={
          <CommonButton
            value={"OK"}
            width={"100%"}
            padding={"10px"}
            marginTop={"1.5rem"}
            fontWeight={"700"}
            fontSize={"15px"}
            disabled={statusDialog.hiredLoading}
            loading={statusDialog.hiredLoading}
            onClick={() => handleStatusChange("hired")}
          />
        }
        title={
          <Typography variant="body4">{statusDialog.hiredData}</Typography>
        }
        titlepadding={"2rem 0px 0px"}
      />

      <AttachmentDialog
        open={attachmentDialog.open}
        handleClose={handleAttachmentClose}
        handleSubmit={handleAttachmentSubmit}
        attachmentDialog={attachmentDialog}
      />

      <ScheduleInterview
        calendlyEvent={calendlyEvent}
        onClose={handleCalendlyClose}
        handleScheduleSubmit={handleScheduleSubmit}
        storageData={storageData}
      />
      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelAttachmentDialogClose}
        handleDeleteSkill={handleDeleteAttachment}
        buttonLoading={deleteButton.loading}
        title="Delete Attachment"
        content={deleteButton.content}
      />

      <DialogCandidateHub
        open={enableQuestion.open}
        handleButttonClose={handleEnableQuestionClose}
        footer={<EnableFooter />}
        title={"Confirm Action"}
        content={enableQuestion.content}
        titlepadding={"0rem 0px 1rem"}
      />

      <DialogCandidateHub
        open={reScore.open}
        closeIcon={true}
        handleButttonClose={handleRescoreClose}
        footer={<ConfirmationButton />}
        icon={<RescoreIco />}
        titlepadding={"0px 0px 16px"}
        customStyle={{ top: "-6px" }}
        content={rescoreContent()}
      />

      <AddPreScreenQuestions
        handleDialogClose={handleDialogClose}
        preScreen={preScreen}
        data={matchedData?.insights?.feedback?.pre_screen_questions_red_flags}
        handleSubmit={handlePreScreenSubmit}
      />
      {review.open && (
        <Review
          review={review}
          handleClose={handleReviewClose}
          negative_flag={negative_flag}
          matchedData={matchedData}
          handleMarkAsReviewed={handleMarkAsReviewed}
        />
      )}
    </Grid2>
  );
}

export default JobsCandidate;
